import type {AdCategory} from '@frontend/modules/public/ads/AdsModuleTypes'

// Поиск категории по ID (рекурсивный).
export function findCategoryById(categories: AdCategory[], id: number | null): null | AdCategory {
    if (!id || id <= 0) {
        return null
    }
    for (const item of categories) {
        if (item.id === id) {
            return item
        } else if (item.children.length) {
            const category: AdCategory | null = findCategoryById(
                item.children,
                id
            )
            if (category) {
                return category
            }
        }
    }
    return null
}
